import { useQueryClient } from '@tanstack/react-query';

import useKeys from './useKeys';

const useInStock = (): boolean => {
  const queryClient = useQueryClient();
  const { stock: keys } = useKeys();
  const cache = queryClient.getQueryData<boolean>(keys);

  return cache || false;
};

export default useInStock;
